import { StyledPaper } from "../../customComponents/styled/styledPaper";
import {
  Typography,
  Box,
  Grid,
  LinearProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import StudentList from "./StudentList";
import AddStudentForm from "./AddStudentForm";
import AddBulkStudent from "./AddBulkStudent";
import GraduatedStudentList from "./GraduatedStudentList";


function Students() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openMenu, setOpenMenu] = useState(true);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (isMobile) {
      setOpenMenu(false);
    }
  };

  return (
    <>
      <Grid container columnSpacing={3}>
        <Grid item xs={12} md={3} lg={2}>
          <StyledPaper>
            {isMobile ? (
              <Accordion expanded={openMenu} onChange={(_, expanded) => setOpenMenu(expanded)} disableGutters>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography sx={{ fontWeight: 600 }}>Menu</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0 }}>
                  <Box
                    component="ul"
                    sx={{
                      listStyle: "none",
                      borderTop: "1px solid #e0e0e0",
                      paddingBottom: 1,
                      "& li": {
                        padding: "10px 14px",
                        color: "primary.safeOnLight",
                        cursor: "pointer",
                        fontSize: "13px",
                        "&.active": {
                          backgroundColor: "primary.main",
                          color: "primary.contrastText",
                        },
                      },
                    }}
                  >
                    <Box component="li" className={activeTab === 0 ? "active" : ""} onClick={() => handleTabChange(0)}>
                      Add New Student
                    </Box>
                    <Box component="li" className={activeTab === 1 ? "active" : ""} onClick={() => handleTabChange(1)}>
                      Add Bulk Student
                    </Box>
                    <Box component="li" className={activeTab === 2 ? "active" : ""} onClick={() => handleTabChange(2)}>
                      Student List
                    </Box>
                    <Box component="li" className={activeTab === 3 ? "active" : ""} onClick={() => handleTabChange(3)}>
                      Graduated Students
                    </Box>
                  </Box>
                </AccordionDetails>
              </Accordion>
            ) : (
              <>
                <Box sx={{ padding: "10px", textAlign: "center" }}>
                  <Typography>MENU</Typography>
                </Box>
                <Box
                  component="ul"
                  sx={{
                    listStyle: "none",
                    borderTop: "1px solid #e0e0e0",
                    paddingBottom: 4,
                    "& li": {
                      padding: "8px 14px",
                      color: "primary.safeOnLight",
                      cursor: "pointer",
                      fontSize: "12px",
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                      },
                      "&.active": {
                        backgroundColor: "primary.main",
                        color: "primary.contrastText",
                      },
                    },
                  }}
                >
                  <Box
                    component="li"
                    className={activeTab === 0 && "active"}
                    onClick={() => setActiveTab(0)}
                  >
                    Add New Student
                  </Box>
                  <Box
                    component="li"
                    className={activeTab === 1 && "active"}
                    onClick={() => setActiveTab(1)}
                  >
                    Add Bulk Student
                  </Box>
                  <Box
                    component="li"
                    className={activeTab === 2 && "active"}
                    onClick={() => setActiveTab(2)}
                  >
                    Student List
                  </Box>
                  <Box
                    component="li"
                    className={activeTab === 3 && "active"}
                    onClick={() => setActiveTab(3)}
                  >
                    Graduated Students
                  </Box>
                </Box>
              </>
            )}
            {loading && <LinearProgress />}
          </StyledPaper>
        </Grid>
        <Grid item xs={12} md={9} lg={10}>
          {activeTab === 0 && <AddStudentForm />}
          {activeTab === 1 && <AddBulkStudent />}
          {activeTab === 2 && <StudentList setLoading={setLoading} />}
          {activeTab === 3 && <GraduatedStudentList />}
        </Grid>
      </Grid>
    </>
  );
}

export default Students;
